import * as React from "react"
import { SelectSeeker } from "@ui-seeker/core";


export default function CatalogueAnalyzerPriceNumProductsToolbar({options, value, handleChangeOption}) {

    return <SelectSeeker
        options={options}
        value={value}
        onChange = {handleChangeOption}
        sx={{ width: 150, textAlign: 'center'}}
    />

}

